angular.module('bb.appointments').component('bbAppointmentTimeChange', {
  bindings: {
    isListingContact: '<?',
  },
  controller: AppointmentTimeChangeController,
  controllerAs: 'vm',
  template: `<appointment-book ng-if="vm.appointment" appointment-details="vm.appointment" is-listing-contact="vm.isListingContact" />`,
});

AppointmentTimeChangeController.$inject = [
  '$routeParams',
  'AppointmentBookService',
];

function AppointmentTimeChangeController($routeParams, AppointmentBookService) {
  const vm = this;

  vm.$onInit = () => {
    vm.appointmentId = $routeParams.appointmentId;
    AppointmentBookService.getAppointmentDetails(vm.appointmentId).then(
      data => {
        vm.appointment = data;
      },
    );
  };
}

export {};
